<template>
  <div class="teacher-view">
    <div class="teacher-bg">
      <div class="teacher-view w">

        <div style="display: flex">
          <div class="other-view height">
            <div class="teacher_title">
              <new-index-title :title="componentInfo.config.title"></new-index-title>

<!--              <NuxtLink to="/tch/list" style="display: flex;align-items: center;margin-left: 20px">-->
<!--                <div class="classify_title_more pointer">-->
<!--                  更多<i class="arrows" />-->
<!--                </div>-->
<!--              </NuxtLink>-->
            </div>

          </div>

          <div style="display: flex;box-sizing: border-box;height: 247px;width: 852px" class="cour-view" @click="toUrl(0)">
            <div class="middle-view height blue padding-view" >

              <template v-if="componentInfo.data && componentInfo.data[0]">
                <div class="teacher-title">
                  <span class="title">{{componentInfo.data[0].nickname}}</span>
                  <span style="margin-left: 15px">高级教师</span>
                </div>

                <div class="teacher-introduce line3">
                  {{componentInfo.data[0].introduce ? componentInfo.data[0].introduce : '暂无'}}
                </div>

<!--                <div class="crow"></div>-->
              </template>

            </div>

            <div class="other-view height">
              <img class="spec-img" src="@/assets/images/new/jsfcjt@2x.png" alt="" style="width: 16px;height: 40px;top:30px;left: 0"/>
<!--              <img v-if="componentInfo.data && componentInfo.data[0]" :src="componentInfo.data[0].headImg" class="img"/>-->
              <img class="img" src="@/assets/images/new/tua@2x.png" alt=""/>
            </div>
          </div>
        </div>

        <div style="display: flex">

          <div class="cour-view1" @click="toUrl(1)">
            <div class="other-view height blue padding-view1">

              <template v-if="componentInfo.data && componentInfo.data[1]">
                <div class="teacher-title">
                  <span class="title">{{componentInfo.data[1].nickname}}</span>
                  <span style="margin-left: 15px">专家</span>
                </div>

                <div class="teacher-introduce line4">
                  {{componentInfo.data[1].introduce ? componentInfo.data[1].introduce : '暂无'}}
                </div>

<!--                <div class="crow"></div>-->
              </template>

            </div>

            <div class="other-view height">
              <img class="spec-img" src="@/assets/images/new/jsfcjtx@2x.png" alt="" style="width: 40px;height: 16px;top:0px;right: 30px"/>
<!--              <img v-if="componentInfo.data && componentInfo.data[1]" :src="componentInfo.data[1].headImg" class="img"/>-->
              <img class="img" src="@/assets/images/new/tud@2x.png" alt=""/>
            </div>

          </div>

          <div class="cour-view1" @click="toUrl(2)">
            <div class="middle-view height">

              <img class="spec-img" src="@/assets/images/new/jsfcjts@2x.png" alt="" style="width: 40px;height: 16px;bottom:0px;right: 30px"/>
<!--              <img v-if="componentInfo.data && componentInfo.data[2]" :src="componentInfo.data[2].headImg" class="img"/>-->
              <img class="img" src="@/assets/images/new/tub@2x.png" alt=""/>
            </div>

            <div class="middle-view height padding-view" style="background: white">
              <template v-if="componentInfo.data && componentInfo.data[2]">
                <div class="teacher-title">
                  <span class="title">{{componentInfo.data[2].nickname}}</span>
                  <span style="margin-left: 15px">高级教师</span>
                </div>

                <div class="teacher-introduce line3">
                  {{componentInfo.data[2].introduce ? componentInfo.data[2].introduce : '暂无'}}
                </div>

<!--                <div class="crow"></div>-->
              </template>
            </div>
          </div>

          <div class="cour-view1" @click="toUrl(3)">
            <div class="other-view height blue padding-view1">

              <template v-if="componentInfo.data && componentInfo.data[3]">
                <div class="teacher-title">
                  <span class="title">{{componentInfo.data[3].nickname}}</span>
                  <span style="margin-left: 15px">高级工程师</span>
                </div>

                <div class="teacher-introduce line4">
                  {{componentInfo.data[3].introduce ? componentInfo.data[3].introduce : '暂无'}}
                </div>

<!--                <div class="crow"></div>-->
              </template>

            </div>

            <div class="other-view height">
              <img class="spec-img" src="@/assets/images/new/jsfcjtx@2x.png" alt="" style="width: 40px;height: 16px;top:0px;right: 30px"/>
<!--              <img v-if="componentInfo.data && componentInfo.data[3]" :src="componentInfo.data[3].headImg" class="img"/>-->
              <img class="img" src="@/assets/images/new/tuc@2x.png" alt=""/>
            </div>
          </div>

        </div>

      </div>
    </div>
  </div>

</template>

<script>
import { useRouter } from 'vue-router'
import { computed, defineComponent, ref } from 'vue'
import { chunk } from 'lodash-es'
export default defineComponent({
  props: {
    componentInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  setup (props, { emit }) {
    const router = useRouter()
    const teacherChunk = computed(() => {
      return chunk(props.componentInfo.data, 5)
    })
    watch(
      ()=>props.componentInfo,(newV) => {
      }
    )
    const num = ref(0)
    const interval = ref(null)
    const change = () => {
      interval.value = setInterval(() => {
        if (num.value + 1 >= teacherChunk.value.length) {
          num.value = 0
        } else {
          num.value++
        }
      }, 5000)
    }
    const mout = () => {
      change()
    }
    const mover = () => {
      clearInterval(interval.value)
    }

    const toUrl = (index) => {
      if (props.componentInfo.data[index]) {
        router.push('/tch/view?id=' + props.componentInfo.data[index].id)
      }
    }

    return {
      num,
      interval,
      mout,
      mover,
      teacherChunk,
      ...toRefs(props),
      toUrl
    }
  }
})
</script>

<!--<script setup>-->
<!--import { useRouter } from 'vue-router'-->
<!--import { chunk } from 'lodash-es'-->
<!--import {computed, watch, ref} from "vue";-->

<!--const props = defineProps({-->
<!--  componentInfo: {-->
<!--    type: Object,-->
<!--    default: () => {-->
<!--      return {}-->
<!--    }-->
<!--  }-->
<!--})-->
<!--const data1 = ref({})-->
<!--const data2 = ref({})-->
<!--const data3 = ref({})-->
<!--const data4 = ref({})-->
<!--const teacherChunk = computed(() => {-->
<!--  console.log('11111111 teacherChunk = ',props.componentInfo)-->

<!--  // if (props.componentInfo.data.length) {-->
<!--  //   data1.value = props.componentInfo.data[0]-->
<!--  //   console.log('11111111 data1 = ',data1.value)-->
<!--  // }-->
<!--  // if (props.componentInfo.data.length > 1) {-->
<!--  //   data2.value = props.componentInfo.data[1]-->
<!--  // }-->
<!--  // if (props.componentInfo.data.length > 2) {-->
<!--  //   data3.value = props.componentInfo.data[2]-->
<!--  // }-->
<!--  // if (props.componentInfo.data.length > 3) {-->
<!--  //   data4.value = props.componentInfo.data[3]-->
<!--  // }-->
<!--  return chunk(props.componentInfo.data, 5)-->
<!--})-->

<!--watch(-->
<!--  () => props.componentInfo, (newValue, oldValue) => {-->
<!--    console.log('11111111 watch = ',newValue)-->
<!--    teacherList.value = newValue.data-->
<!--    if (newValue.data.length) {-->
<!--      data1.value = newValue.data[0]-->
<!--      console.log('11111111 data1 = ',data1.value)-->
<!--    }-->
<!--    if (newValue.data.length > 1) {-->
<!--      data2.value = newValue.data[1]-->
<!--    }-->
<!--    if (newValue.data.length > 2) {-->
<!--      data3.value = newValue.data[2]-->
<!--    }-->
<!--    if (newValue.data.length > 3) {-->
<!--      data4.value = newValue.data[3]-->
<!--    }-->
<!--  }-->
<!--)-->

<!--// console.log('11 teacherChunk = ',teacherChunk)-->

<!--// const prop = defineProps({-->
<!--//   datas:{-->
<!--//     type:Array,-->
<!--//     default: []-->
<!--//   }-->
<!--// })-->
<!--//-->
<!--const router = useRouter()-->
<!--const teacherList = ref([])-->
<!--//-->
<!--// watch(-->
<!--//   () => prop.datas, (newValue, oldValue) => {-->
<!--//     console.log('newValue = ',newValue)-->
<!--//     teacherList.value = newValue-->
<!--//     console.log('teacherList newValue = ',teacherList.value)-->
<!--//     //-->
<!--//     // console.log('newValue = ',teacherList.value)-->
<!--//   }-->
<!--// )-->
<!--//-->
<!--const toUrl = (index) => {-->
<!--  if (teacherList.value[index]) {-->
<!--    router.push('/tch/view?id=' + teacherList.value[index].id)-->
<!--  }-->
<!--}-->

<!--</script>-->

<style scoped lang="scss">
.teacher-bg{
  width: 100%;
  background: url("@/assets/images/new/msfcbj@2x.png") no-repeat;
  background-size: cover;
  height: 519px;
  padding-top: 25px;
}

.cour-view{
  cursor: pointer;
  box-sizing: border-box;
  &:hover{
    border: #FDD000 2px solid;

    .middle-view{
      width: 502px;
    }

    .height{
      height: 243px;
    }

    .other-view{
      width: 346px;
    }
  }
}

.cour-view1{
  cursor: pointer;
  box-sizing: border-box;
  &:hover{
    border: #FDD000 2px solid;

    .middle-view{
      width: 500px;
    }

    .height{
      height: 245px;
    }

    .other-view{
      width: 344px;
    }
  }
}

.teacher-view{
  height: 791px;
}

.middle-view{
  width: 504px;
  position: relative;
}

.other-view{
  width: 348px;
  position: relative;
}
.spec-img{
  position: absolute;
}

.blue{
  background-color: rgba(24,101,190,0.71);
  color:white;

  .crow{
    background: url("@/assets/images/new/fsfcjt@2x.png") no-repeat;
    background-size: contain;
  }
}

.padding-view{
  padding: 50px 44px 36px 44px;
}

.padding-view1{
  padding: 40px 60px 40px 60px;
}

.img{
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.teacher-title{
  display: flex;
  align-items: center;
  .title{
    font-size: 20px;
  }
}

.crow{
  margin-top: 30px;
  width: 25px;
  height: 13px;
  background: url("@/assets/images/new/msfcjt@2x.png") no-repeat;
  background-size: contain;
}

.teacher-introduce{
  margin-top: 25px;
  text-overflow: ellipsis;
  display: -webkit-box;
  word-break: break-all;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.line3{
  width: 410px;
  height: 65px;
  -webkit-line-clamp: 3;
}

.line4{
  width: 225px;
  height: 80px;
  -webkit-line-clamp: 4;
}

.height{
  height: 247px;
}

.teacher_title{
  display: flex;

  .classify_title_more{
    margin-top: 10px;
  }
}
</style>
